import { graphql } from "gql.tada";

export const GetAllLocaleSettings = graphql(
  /* GraphQL */ `
    query GetAllLocaleSettings($locale: String, $preview: Boolean) {
      localeCollection(locale: $locale, preview: $preview, limit: 250) {
        items {
          id
          name
          localName
          defaultForRegion
          active
          lineBreaksAllowed
          locked
          resolveTo {
            id
          }
          mobileFontScaling
          desktopFontScaling
          lineHeightScaling
        }
      }
    }
  `,
  []
);
